import React from "react";
import { useEffect, useState } from "react";
import { useAlert } from "../../hooks";
import useNetworkStatus from "../../hooks/useNetworkStatus";
import SnackbarGeneric from "../SnackbarGeneric/SnackbarGeneric";
import { useSelector } from "react-redux";
import { IRootState } from "../../state";
import { IToastMessageState } from "../../state/request";
import { DEFAULT_ERROR, DISABLE_ALERT_MESSAGES } from "../../config/errors-map";
import LoadingBackdrop from "../LoadingBackdrop/LoadingBackdrop";


const SnackbarWrapper: React.FC = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const { clearAlerts } = useAlert();
  useNetworkStatus();

  const { error, isLoading, message, severity, customIcon, alertType, customMessage } = useSelector(
    (state: IRootState) => state.toastMessage as IToastMessageState,
  );

  const handleClose = () => {
    clearAlerts();
    setOpenSnackbar(false);
  };

  useEffect(() => {
    if (!isLoading && (error || message)) {
      if (!DISABLE_ALERT_MESSAGES.includes(error?.[0]?.message!)) {
        setOpenSnackbar(true);
      }
    } else {
      setOpenSnackbar(false);
    }
  }, [error, message, isLoading]);

  return (
    <>
      {openSnackbar && <SnackbarGeneric
        message={message || error?.[0]?.message || DEFAULT_ERROR}
        open={openSnackbar}
        onClose={handleClose}
        severity={severity}
        customIcon={customIcon}
        alertType={alertType}
        customMessage={customMessage}
      />
      }
      {isLoading && <LoadingBackdrop />}
    </>
  );
};

export default SnackbarWrapper;
